<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/inquiryform",
        "headline":"Hot Linux ／ WEBシステム開発（ご相談・お問い合わせ）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。簡単なことでも構いません。お気軽にお問い合わせ・ご相談ください。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>

    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6" class='mb-5'>
        <v-breadcrumbs
          icon="mdi-email-edit-outline"
          bg-color="grey-lighten-4"
          rounded
        >
          <h3>ご相談・お問い合わせ</h3>
        </v-breadcrumbs>
        <v-card  class='mx-3 mt-3 mb-5'>
          <v-card-text>
            <v-form v-model='valid' ref="mailForm">
              <v-row dense>
                <v-col>
                  <v-text-field
                    label="お名前"
                    variant="outlined"
                    v-model="名前"
                    placeholder="山田太郎"
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field
                    type="email"
                    label="メールアドレス"
                    variant="outlined"
                    placeholder="yamada@hot-linux.dev"
                    v-model="メールアドレス"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-select
                    bg-color="white"
                    :items='サービスrtn'
                    item-value="タイトル"
                    item-title="タイトル"
                    label="ご相談内容"
                    v-model='タイトル'
                    variant="outlined"
                    :rules="nameRules"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-textarea
                    label="詳細"
                    variant="outlined"
                    v-model="内容"
                    :rules="nameRules"
                  ></v-textarea>
                </v-col>
              </v-row >
              <v-row dense>
                <v-col>
                </v-col>
                <v-col cols=auto>
                  <v-btn
                    @click='テンプレ入力()'
                  >テンプレート入力</v-btn>
                </v-col>
              </v-row>
              <v-divider class='my-4'></v-divider>

              <v-row dense>
                <v-col>
                  ご希望の返信形式
                  <v-radio-group inline v-model='返信形式' dense hide-details="true">
                    <v-radio label='メール' value='メール'></v-radio>
                    <v-radio label='Slack' value='Slack'></v-radio>
                    <v-radio label='Chatwork' value='Chatwork'></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  SlackやChatworkがおすすめです。ご要望の詳細なヒアリングやお打ち合わせがスムーズに行えます。
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-btn
                    @click='confirmDialog=true'
                    block
                    :disabled='!valid'
                    class='mb-4 primary'
                    color='primary'
                  >確認</v-btn>
                  <v-dialog
                    v-model="confirmDialog"
                    transition="dialog-bottom-transition"
                    max-width="800"
                  >
                    <v-card>
                      <v-card-title>
                        確認
                      </v-card-title>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              v-model='名前'
                              label="お名前"
                              readonly
                              variant="underlined"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              v-model="メールアドレス"
                              label="メールアドレス"
                              readonly
                              variant="underlined"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              v-model="タイトル"
                              label="タイトル"
                              readonly
                              variant="underlined"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-textarea
                              v-model="内容"
                              label="詳細"
                              variant="underlined"
                              readonly
                            >内容</v-textarea>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              v-model="返信形式"
                              label="ご希望の返信形式"
                              readonly
                              variant="underlined"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn @click='confirmDialog=false'>
                          <v-icon size='x-large'>mdi-arrow-left</v-icon>
                          戻る
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          @click='問い合わせ保存()'
                        >
                          <v-icon size='x-large'>mdi-email-fast-outline</v-icon>
                          送信
                        </v-btn>

                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row class='my-5'>
                <v-col>
                  <v-divider
                
                  ></v-divider>
                </v-col>
                <v-col cols='auto'>
                  または
                </v-col>
                <v-col>
                  <v-divider
                  ></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    block
                    color="success"
                    @click='onClickLine()'
                    >LINEで相談する</v-btn>
                </v-col>
              </v-row>

            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LeftSide from './LeftSide.vue'
export default {
  components: {LeftSide },
  data(){
    return {
      confirmDialog:false,
      名前:"",
      メールアドレス:"",
      タイトル:null,
      内容:null,
      返信形式:"メール",
      valid:false,
      nameRules:[
        v => !!v || '必須です',
      ],
      emailRules:[
        v => !!v || "必須です",
        v => /.+@.+/.test(v) || '形式が違います',
      ],
      isLoading:false,
      サービスrtn:[],
    }
  },

  mounted(){

    this.サービス取得();
  },

  methods:{
    テンプレ入力(){
      if(window.confirm("詳細に入力中の内容はリセットされます。ご注意下さい。")){
        this.内容 = "【概要】(ご要望を教えて下さい)\n\n\n";
        this.内容 += "【ご予算】\n\n\n";
        this.内容 += "【ご希望納期】\n\n\n";
      }

    },

    サービス取得(){
      this.$emit('overlay');
      let url = './api/api.php';
      let data = {
        func:"サービス取得",
        pageSize:10,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.サービスrtn = result.サービスrtn;
        this.サービスrtn.push({"タイトル":"その他"})
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('取得できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },

    問い合わせ保存(){
        this.$emit('overlay');

        let url = '../api/api.php';
        let data = {
          func:"問い合わせ保存",
          名前:this.名前,
          タイトル:this.タイトル,
          内容:this.内容,
          メールアドレス:this.メールアドレス,
          返信形式:this.返信形式,
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          console.log(result);
          this.confirmDialog = false;
          this.$refs.mailForm.reset();
          this.返信形式 = "Slack"
          this.$emit('overlay');
          alert("ご相談ありがとうございます。一両日中にはご希望の形式で返信いたします。少々お待ちください。");
        })
        .catch(error =>{
          alert('送信できませんでした。\n\n'+error.body);
          console.log(error)
          this.$emit('overlay');
        })
      this.confirmDialog = false;
    },

    onClickLine(){
      window.open("https://lin.ee/XRhQTGa")
    }

  },
}
</script>